import React, {useContext} from 'react';
import {Context} from "../store/reducer";

const Component = () => {
    
    const { state, dispatch } = useContext(Context);

    /**
     * 注意事項ポップアップを閉じる。
     * ポップアップの開閉状態はstateで管理する。
     * 再度開くボタンはVis4PopupReopenButtonである。
     */
    const closeModal = () => {
        dispatch({
            type: 'SET_IS_VIS4_POPUP_OPENED',
            payload: false
        })
    }
    
    return (state.isVis4PopupOpened && <>
        <div className="modal-first">
            <div className="modal-first-inner">

                <h3 className="u-fs-16 u-txt-c u-pb-xs u-lh-sm">【法規制マップ利用上の注意事項等】</h3>
                <section className="u-pb-xs">
                    <h4 className="u-fs-14 u-pb-xxs" style={{color: "red", fontWeight: "bolder"}}>１ 法規制マップについて【重要】</h4>
                    <p className="u-fs-12 u-lh-sm" style={{color: "red"}}>このマップでは、画面上で指定した箇所について，適用される関係法令の規制区域や規制内容，手続先を画面上で確認することができます。
                        マップの使用方法は次のとおりです。
                    </p>
                </section>
                
                <section className="u-pb-xs">
                    <h5 style={{}}>【使用方法】</h5>
                    <ol className="p-number-list u-lh-sm">
                        <li>
                            <span className="u-fs-12">
                                マップ左側上部の「設定」をクリックし，関係法令の一覧を表示します。
                            </span>
                        </li>
                        <li>
                            <span className="u-fs-12">
                                表示された一覧のうち，マップ上に表示させる関係法令に☑をいれます。（チェックを入れるとマップ上に規制区域が表示されます。）
                            </span>
                        </li>
                        <li>
                            <span className="u-fs-12">
                                マップ上の任意の箇所をクリックすると，その箇所に適用される関係法令がウインドウに表示されます。
                            </span>
                        </li>
                        <li>
                            <span className="u-fs-12">
                                ウインドウ内に表示された法令名をクリックすると，データカタログ画面に移動し，当該法令の規制内容及び手続先がエクセルでダウンロードできます。
                            </span>
                        </li>
                    </ol>
                </section>
                
                
                
                <section className="u-pb-xs">
                    <h4 className="u-fs-14 u-pb-xxs u-lh-sm" style={{fontWeight: "bolder"}}>２ GISマップご利用にあたって（免責事項）</h4>
                    <div className="u-fs-12 u-lh-sm u-pb-sm">
                        <p className="u-pb-xs">(1)
                            公開しているデータは、区域や土地の境界または建物等の位置を正確に示すものではありません。またその表示位置は、欠損やズレが生じる場合があります。</p>
                        <p className="u-pb-xs">(2)
                            森林法のうち地域森林計画対象民有林区域については、広島市、福山市、東広島市、廿日市市、三次市、世羅町、安芸高田市、北広島町、庄原市の9市町のデータのみ表示しています。9市町以外の市町においても地域森林計画の対象とする区域がありますので、手続き先等にお問い合わせください。9市町以外の市町のデータは今後整備を行い、表示する予定です。</p>
                        <p>(3)
                            次の法令等については、規制区域等が存在しない、又は、区域データの整備が行われていない、などの理由により表示されません。今後、区域データの整理ができたものから順次、表示する予定ですが、規制区域の確認等については、手続き先等にお問い合わせください。</p>
                    </div>
                    <div className="u-pb-xs">
                        <h5>［今後区域データの整備を行う予定の法令等］</h5>
                        <ul className="u-fs-12">
                            <li>・森林法（地域森林計画の対象とする区域）</li>
                            <li>・道路法</li>
                            <li>・河川法</li>
                            <li>・文化財保護法・広島県文化財保護条例</li>
                        </ul>
                    </div>
                    <div className="u-pb-xs">
                        <h5>［区域指定がない法令等］</h5>
                        <ul className="u-fs-12">
                            <li>・建設工事に係る資材の再資源化等に関する法律</li>
                            <li>・広島県土砂の適正処理に関する条例</li>
                            <li>・土壌汚染対策法</li>
                        </ul>
                    </div>
                    <div className="u-fs-12 u-lh-sm">
                        <p
                          className="u-pb-xs">・規制区域等について、申請、届出等を行う場合や不動産取引等の資料など、より詳細な情報が必要な場合は、必ず各法令等の手続き先等にお問い合わせください。</p>
                        <p
                          className="u-pb-xs">・本コンテンツで公開しているデータの正確性、最新性、完全性、特定の目的への適合性について一切保証いたしませんので、利用者の責任においてご利用ください。公開しているデータは、広島県に関する情報の一部であって、その全てを網羅するものではありません。</p>
                        <p
                          className="u-pb-xs">・本コンテンツのアドレスや公開しているデータは、事前に予告することなく変更、移転、削除等が行われることがあります。</p>
                        <p className="u-pb-xs">・広島県は、利用者が本コンテンツの情報を用いて行う一切の行為について、いかなる責任も負いません。</p>
                        <p
                          className="u-pb-xs">・広島県は、直接・間接的な理由を問わず、本コンテンツを利用したことにより発生した損害・損失、不利益等について、いかなる場合でも一切の責任を負いません。</p>
                        <p>・全ての閲覧者または機器上で正常に利用できることを保証するものではありません。利用する機器の環境においては、本データが正常に閲覧等できない場合があります。</p>
                    </div>
                </section>

                <section className="u-pb-sm">
                    <dl>
                        <dt>[出典]</dt>
                        <dd className="u-fs-12"><a
                          href="https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-N03-v3_1.html#prefecture34"
                          target="_blank">国土数値情報 行政区域データ</a> を加工して作成
                        </dd>
                        <dd className="u-fs-12"><a href="https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-A45.html"
                                                   target="_blank">国土数値情報 国有林野データ</a> を加工して作成
                        </dd>
                    </dl>
                </section>
                
                <p class="u-txt-c" onClick={closeModal}><span style={{"text-decoration": "underline", "cursor": "pointer"}}>閉じる</span></p>
            </div>
        </div>
    </>);
}

export default Component
